import request from '../utils/request'

export default {
  // 获取所有角色
  findAll(params) {
    return request.get('/api/role', { params })
  },
  
  // 根据ID获取角色
  findById(id) {
    return request.get(`/api/role/${id}`)
  },
  
  // 添加角色
  add(role) {
    return request.post('/api/role', role)
  },
  
  // 更新角色
  update(id, role) {
    return request.put(`/api/role/${id}`, role)
  },
  
  // 删除角色
  delete(id) {
    return request.delete(`/api/role/${id}`)
  },
  
  // 批量删除角色
  deleteBatch(ids) {
    return request.delete('/api/role/batch', { data: ids })
  },
  
  // 为角色分配权限
  assignPermissions(roleId, permissionIds) {
    return request.post(`/api/role/${roleId}/permissions`, permissionIds)
  },
  
  // 根据用户ID查询角色
  findByUserId(userId) {
    return request.get(`/api/role/user/${userId}`)
  },

  // 检查角色名是否存在
  checkRoleCode(params) {
    return request.get('/api/role/checkRoleCode', { params })
  },
}
